<template>
    <div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>外文官网</el-breadcrumb-item>
          <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="operating">
        <router-link :to="{path: 'languageGame'}">
          <el-button
            type="primary"
            size="small"
          >取消</el-button>
        </router-link>
        <el-button
          :loading="loading"
          type="primary"
          size="small"
          @click="store"
        >保存</el-button>
      </div>
      <div>
        <el-form :model="form" label-width="100px" :rules="rules" ref="form">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="游戏名称" prop="name" >
                <el-input v-model="form.name" auto-complete="off" placeholder="请输入游戏名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="所属官网" prop="language" >
                <el-select v-model="form.language" @change="languageChangeHandle" placeholder="请选择" style="width: 100%">
                  <el-option
                    v-for="item in language"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="PC端游戏展示图片" prop="pc_file_id" >
                <el-upload
                  v-loading="uploadPcLoading"
                  class="upload-demo"
                  drag
                  action="#"
                  :before-upload="beforeAvatarUpload"
                  :on-change="handleFileChange"
                  :http-request="submitPcUpload"
                  :auto-upload="true"
                  :limit="1"
                  :on-remove="removePcFile"
                  :file-list="form.pc_file_list"
                  accept=".jpg,.png,.jpeg"
                  ref="pc"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传jpg/png文件 英文官网尺寸：530*390 韩文官网尺寸：600*360</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="PC端游戏描述" prop="pc_desc" >
                <el-input
                  type="textarea"
                  :rows="3"
                  :maxlength="pcLimit"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="form.pc_desc">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="手机端游戏展示图片" prop="mb_file_id" >
                <el-upload
                  v-loading="uploadMbLoading"
                  drag
                  action="#"
                  :before-upload="beforeAvatarUpload"
                  :on-change="handleMbFileChange"
                  :http-request="submitMbUpload"
                  :auto-upload="true"
                  :file-list="form.mb_file_list"
                  :on-remove="removeMbFile"
                  accept=".jpg,.png,.jpeg"
                  ref="mb"
                  :limit="1"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传jpg/png文件 英文官网尺寸：750*543 韩文官网尺寸：750*317</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机端游戏描述" prop="mb_desc" >
                <el-input
                  type="textarea"
                  :rows="2"
                  :maxlength="mbLimit"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="form.mb_desc">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
</template>

<script>
import {uploadImg} from '../../../api'
import {getInfo, storeGame} from '../../../api/language/game'

export default {
  data () {
    return {
      loading: false,
      uploadPcLoading: false,
      uploadMbLoading: false,
      pcLimit: 50,
      mbLimit: 25,
      form: {
        id: 0,
        name: '',
        language: '',
        mb_desc: '',
        pc_desc: '',
        pc_file_id: '',
        mb_file_id: '',
        pc_file_path: '',
        mb_file_path: '',
        pc_file_list: [],
        mb_file_list: []
      },
      rules: {
        name: [
          {required: true, message: '请输入游戏名称', trigger: 'blur'}
        ],
        language: [
          {required: true, message: '请选择所属官网', trigger: 'change'}
        ],
        pc_desc: [
          {required: true, message: '请输入PC端游戏描述', trigger: 'blur'}
        ],
        mb_desc: [
          {required: true, message: '请输入手机端游戏描述', trigger: 'blur'}
        ],
        pc_file_id: [
          {required: true, message: '请上传PC端游戏展示图片', trigger: 'change'}
        ],
        mb_file_id: [
          {required: true, message: '请上传移动端端游戏展示图片', trigger: 'change'}
        ]
      },
      language: [
        {
          value: 1,
          label: '英文官网'
        },
        {
          value: 2,
          label: '韩文官网'
        }
      ],
      file: {}
    }
  },
  mounted () {
    this.info()
  },
  methods: {
    languageChangeHandle (val) {
      if (val === 1) {
        this.pcLimit = 110
        this.mbLimit = 60
      } else {
        this.pcLimit = 50
        this.mbLimit = 25
      }
    },
    info () {
      let id = this.$route.query.id
      if (!id) {
        return false
      }
      getInfo({game_id: id}).then(res => {
        if (res.status === 2000) {
          this.form = res.data
          this.form.pc_file_id = res.data.pc_file.id
          this.form.pc_file_path = res.data.pc_file.file_path
          this.form.pc_file_list = [{name: res.data.pc_file.filename, url: res.data.pc_file.file_path}]
          this.form.mb_file_id = res.data.mb_file.id
          this.form.mb_file_path = res.data.mb_file.file_path
          this.form.mb_file_list = [{name: res.data.mb_file.filename, url: res.data.mb_file.file_path}]
        } else {
          this.$notify({
            message: res.message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
          this.$router.push({path: 'languageGame'})
        }
      })
    },
    store () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          storeGame(this.form).then(res => {
            if (res.status === 2000) {
              this.$router.push({path: 'languageGame'})
            }
            this.loading = false
            this.$notify({
              message: res.message,
              type: res.status === 2000 ? 'success' : 'warning',
              offset: 100,
              showClose: false
            })
          })
        }
      })
    },
    // 上传前回调
    beforeAvatarUpload (file) {
      const isImg = ['image/jpeg', 'image/png', 'image/jpg'].indexOf(file.type) >= 0
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isImg && isLt2M
    },
    // 上传snapshot文件，获取文件流
    handleFileChange (file) {
      this.file = file.raw
      this.$refs.pc.clearFiles()
    },
    handleMbFileChange (file) {
      this.file = file.raw
      this.$refs.mb.clearFiles()
    },
    // mb图片上传
    submitMbUpload () {
      let form = new FormData()
      this.uploadMbLoading = true
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.mb_file_id = res.data.file_id
          this.form.mb_file_path = res.data.file_path
          this.form.mb_file_list = [{name: res.data.file_name, url: res.data.file_path}]
        }
        this.uploadMbLoading = false
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    },
    // pc图片上传
    submitPcUpload () {
      let form = new FormData()
      this.uploadPcLoading = true
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.pc_file_id = res.data.file_id
          this.form.pc_file_path = res.data.file_path
          this.form.pc_file_list = [{name: res.data.file_name, url: res.data.file_path}]
        }
        this.uploadPcLoading = false
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    },
    removePcFile () {
      this.form.pc_file_id = ''
      this.form.pc_file_path = ''
    },
    removeMbFile () {
      this.form.mb_file_id = ''
      this.form.mb_file_path = ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/language/game/store.vue